import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  modalOpen: false,
  awardedBadges: [],
  loading: false,
};

const notifications = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    showNotification(state, action) {
      const { awardedBadges } = action.payload;
      if (state.modalOpen) {
        const newBadges = awardedBadges.filter(
          (badge) => !state.awardedBadges.some((existingBadge) => existingBadge.id === badge.id)
        );
        state.awardedBadges.push(...newBadges);
      } else {
        const sortedBadges = awardedBadges.sort((a, b) => {
          if (a.group_order === null && b.group_order !== null) {
            return 1;
          }
          if (a.group_order !== null && b.group_order === null) {
            return -1;
          }
          if (a.group_order === b.group_order) {
            if (a.sort_order === b.sort_order) {
              return a.name.localeCompare(b.name);
            }
            return (a.sort_order || 0) - (b.sort_order || 0);
          }
          return (a.group_order || 0) - (b.group_order || 0);
        });

        state.awardedBadges = sortedBadges;
        state.modalOpen = true;
      }
    },
    closeNotification(state) {
      state.modalOpen = false;
      state.awardedBadges = [];
    },
    checkUnseenBadgesAction(state) {
      state.loading = true;
    },
    checkUnseenBadgesFinished(state) {
      state.loading = false;
    },
  },
});
export const notificationAction = notifications.actions;
export default notifications.reducer;
